import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

/**
 * NoPermission Component
 * Displays a \"no permission\" message.
 *
 * @param {Object} props
 * @param {string} props.message - Custom message (optional)
 * @param {string} props.title - Custom title (optional)
 */
const NoPermission = ({
  message = "you don't have permission to access this page",
  title = "access denied",
}) => {
  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 6,
          textAlign: "center",
          bgcolor: "#F8F9FA",
          borderRadius: 3,
          maxWidth: 500,
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              bgcolor: "#FFE5E5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LockIcon sx={{ fontSize: 40, color: "#FF5722" }} />
          </Box>

          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, color: "#333", mb: 1 }}>
              {title}
            </Typography>
            <Typography variant="body1" sx={{ color: "#666", textTransform: "lowercase" }}>
              {message}
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default NoPermission;

